<template>
<v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
        <v-flex xs12 md44 class="my-3">
            <div class="text-xs-center">
        <div id="firebaseui-auth-container">
            <p id="leadmsg">友達とチームを作ってバスケをしよう</p></div>

        <div id="loader">Loading...</div>
        <p id="termmessage">ログインすることで、あなたはACTIVE HOOPの
          <router-link to="/terms" target="_blank">利用規約</router-link>、
          <router-link to="/privacypolicy" target="_blank">プライバシーポリシー</router-link>
          に同意したことになります。</p>
            </div>
    </v-flex>
    </v-flex>
  </v-layout>
</v-container>
</template>


<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase'
import firebaseui from 'firebaseui'
const uiConfig = {
  signInSuccessUrl: '/#/',
  callbacks: {
    signInSuccess: function (currentUser, credential, redirectUrl) {
      console.log('redirectUrl->', redirectUrl)
      // firestore
      var db = firebase.firestore()
      db.collection('users').doc(currentUser.uid).set({
        name: currentUser.displayName,
        email: currentUser.email,
        photoURL: currentUser.photoURL,
        time: new Date().getTime()
      })
    .then(function (docRef) {
      console.log('Document written with ID: ', docRef.id)
    })
    .catch(function (error) {
      console.error('Error adding document: ', error)
    })

      return true
    },
    uiShown: function () {
      // The widget is rendered.
      // Hide the loader.
      document.getElementById('loader').style.display = 'none'
    }
  },
  credentialHelper: firebaseui.auth.CredentialHelper.NONE,
  signInOptions: [
    // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
    // firebase.auth.GithubAuthProvider.PROVIDER_ID,
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    firebase.auth.FacebookAuthProvider.PROVIDER_ID
  ],
  tosUrl: '/#tos'
}
export default {
  name: 'auth',
  computed: {
    ...mapGetters({
      fbUiApp: 'fbUiApp'
    })
  },
  mounted () {
    this.fbUiApp.start('#firebaseui-auth-container', uiConfig)
  },
  destroyed () {
    this.fbUiApp.reset()
  }
}
</script>

<style src="firebaseui/dist/firebaseui.css"></style>
<style>
#leadmsg {
    font-size: 17px;
    font-weight: 700;
    color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/user/Auth.vue